import { render, staticRenderFns } from "./DeleteFile.vue?vue&type=template&id=0777887a&"
import script from "./DeleteFile.vue?vue&type=script&lang=ts&"
export * from "./DeleteFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports